import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { EditCustomTablePageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import FormModal from 'modules/employees/components/CustomTables/FormModal'
import { RouteContext } from 'modules/employees/pages/CustomTablesListPage/context'

export default function EditCustomTablePage() {
  const {
    id: employeeIdparam,
    schemaId,
    valueId,
  } = useStrictParams<'id' | 'schemaId' | 'valueId'>()
  const navigate = useNavigate()
  const { employee: sessionEmployee } = useCurrentSession()

  const employeeId = employeeIdparam ? Number(employeeIdparam) : sessionEmployee.id

  const { data } = useQuery(EditCustomTablePageDocument, {
    variables: {
      employeeId: employeeId,
      schemaId: Number(schemaId),
      valueId: Number(valueId),
    },
    skip: !schemaId || !valueId,
  })

  const schema = data?.customResources.schema
  const resourceValue = data?.customResources.value
  const currency = data?.employees.employee?.legalEntity?.currency ?? ''
  const canRemoveCustomTableRecords =
    data?.employees?._policies?.removeCustomTableRecords?.can ?? false

  const rootRoute = React.useContext(RouteContext)

  if (!schema || !resourceValue) return null

  const onClose = () => {
    !!rootRoute && navigate(rootRoute.customTablesIndex())
  }

  return (
    <FormModal
      schema={schema}
      employeeId={employeeId}
      currency={currency}
      resourceValue={resourceValue}
      canRemoveCustomTableRecords={canRemoveCustomTableRecords}
      onClose={onClose}
    />
  )
}
